import { MemoExoticComponent } from 'react';
import { SubjectType } from '@surveycake/logic-engine';
import TextShort from './TextShort';
import TextLong from './TextLong';
import DigitInput from './DigitInput';
import DigitSlide from './DigitSlide';
import RatingBar from './RatingBar';
import FileUpload from './FileUpload';
import Quote from './Quote';
import Statement from './Statement';
import DatePicker from './DatePicker';
import Divider from './Divider';
import ItemSort from './ItemSort';
import Nest from './Nest';
import ChoiceOne from './ChoiceOne';
import ChoiceMulti from './ChoiceMulti';
import Pickfrom from './PickFrom';

export type SubjectMap = {
  [type in SubjectType]: MemoExoticComponent<() => JSX.Element>;
};

export const subjectMap: SubjectMap = {
  TXTSHORT: TextShort,
  TXTLONG: TextLong,
  DIGITINPUT: DigitInput,
  DIGITSLIDE: DigitSlide,
  ITEMSORT: ItemSort,
  RATINGBAR: RatingBar,
  FILEUPLOAD: FileUpload,
  QUOTE: Quote,
  STATEMENT: Statement,
  DATEPICKER: DatePicker,
  DIVIDER: Divider,
  NEST: Nest,
  CHOICEONE: ChoiceOne,
  CHOICEMULTI: ChoiceMulti,
  PICKFROM: Pickfrom
};
